export default __webpack_public_path__ + "static/media/penang2017A.abd95638.jpg";